module.exports = __webpack_public_path__ + "static/media/rope.da97f792.png";